var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('h3',{staticClass:"col-sm-12"},[_vm._v("Áreas")])])])
}]

export { render, staticRenderFns }